<template>
  <div class="save-footer">
    <v-alert v-if="error" type="error" dense text class="mb-0 save-footer__alert">
      {{ error }}
    </v-alert>
    <v-card-actions class="pa-0 pt-4">
      <v-spacer />
      <v-btn v-if="$listeners.cancel" text :disabled="saving" @click="$emit('cancel')">
        Cancel
      </v-btn>
      <v-btn color="primary" :loading="saving" :disabled="saving" @click="$emit('save')">
        Save
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
  export default {
    name: 'EventCategorySaveFooter',
    props: {
      error: { type: String, default: '' },
      saving: { type: Boolean, default: false }
    }
  }
</script>

<style scoped lang="scss">
.save-footer {
  margin-top: 8px;

  &__alert {
    width: 100%;
  }
}
</style>
